import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=6ac5bffa&scoped=true"
import script from "./ConfirmEmail.vue?vue&type=script&lang=ts"
export * from "./ConfirmEmail.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmEmail.vue?vue&type=style&index=0&id=6ac5bffa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0._83348a1cf597b13f55aa1c5cb85cf58d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac5bffa",
  null
  
)

export default component.exports